/*
 * MarketPage Messages
 *
 * This contains all the text for the MarketPage container.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.containers.LandingPage.FarmToTablePage';

export default defineMessages({
  productSourceTitle: {
    id: `${scope}.productSourceTitle`,
    defaultMessage: 'Cách Kamereo',
  },
  productSourceHighlightTitle: {
    id: `${scope}.productSourceHighlightTitle`,
    defaultMessage: 'kết nối nông trại với doanh nghiệp',
  },
  seeMore: {
    id: `${scope}.seeMore`,
    defaultMessage: 'Xem thêm ({count})',
  },
  collapse: {
    id: `${scope}.collapse`,
    defaultMessage: 'Thu gọn',
  },
  contactUs: {
    id: `${scope}.contactUs`,
    defaultMessage: 'Liên hệ',
  },
  become: {
    id: `${scope}.become`,
    defaultMessage: 'Trở thành',
  },
  contactUsSuccess: {
    id: `${scope}.contactUsSuccess`,
    defaultMessage: 'Đã liên hệ thành công',
  },
  contact: {
    id: `${scope}.contact`,
    defaultMessage: 'Liên hệ',
  },
  registerNow: {
    id: `${scope}.registerNow`,
    defaultMessage: 'Đăng ký ngay',
  },
  aboutUs: {
    id: `${scope}.aboutUs`,
    defaultMessage: 'Về chúng tôi',
  },
  explorerMore: {
    id: `${scope}.explorerMore`,
    defaultMessage: 'Trang chủ',
  },
  registerSuccess: {
    id: `${scope}.registerSuccess`,
    defaultMessage: 'Đăng ký thành công!',
  },
  subTextContact: {
    id: `${scope}.subTextContact`,
    defaultMessage:
      'Chúng tôi đã nhận được thông tin của bạn. Đội ngũ chăm sóc khách hàng sẽ liên hệ với bạn {workingTime}',
  },
  subTextContactBelow: {
    id: `${scope}.subTextContactBelow`,
    defaultMessage: 'Nếu bạn cần hỗ trợ gấp? Gọi ngay ',
  },
  learnMoreUs: {
    id: `${scope}.learnMoreUs`,
    defaultMessage: 'Khám phá thêm về Kamereo',
  },
  sendInfo: {
    id: `${scope}.sendInfo`,
    defaultMessage: 'Gửi thông tin',
  },
  bannerSubtextLoggin: {
    id: `${scope}.bannerSubtextLoggin`,
    defaultMessage: 'Những sản phẩm thiết yếu tại Kamereo được hàng ngàn doanh nghiệp F&B tại Việt Nam tin dùng.',
  },
  bannerSubtextNonLoggin: {
    id: `${scope}.bannerSubtextNonLoggin`,
    defaultMessage: 'Đăng ký ngay để nhận được giá tốt hơn và ưu đãi riêng cho doanh nghiệp F&B.',
  },
  getProductConsultation: {
    id: `${scope}.getProductConsultation`,
    defaultMessage: 'Nhận tư vấn',
  },
  purchaseFromFavorite: {
    id: `${scope}.purchaseFromFavorite`,
    defaultMessage: 'Mua lại từ yêu thích',
  },
  purchaseFromKamereoLabel: {
    id: `${scope}.purchaseFromKamereoLabel`,
    defaultMessage: 'Khám Phá Thương Hiệu Kamereo',
  },
  viewDetail: {
    id: `${scope}.viewDetail`,
    defaultMessage: 'Xem chi tiết',
  },
  seeAll: {
    id: `${scope}.seeAll`,
    defaultMessage: 'Xem tất cả',
  },
  workingTime: {
    id: `${scope}.workingTime`,
    defaultMessage: 'trong vòng 24h làm việc.',
  },
  createPurchaseAccount: {
    id: `${scope}.createPurchaseAccount`,
    defaultMessage: 'Tạo tài khoản nhập hàng',
  },
  exploreKamereoFresh: {
    id: `${scope}.exploreKamereoFresh`,
    defaultMessage: 'Khám phá KAMEREO Ngon',
  },
  kamereoCustomerContactDescription: {
    id: `${scope}.kamereoCustomerContactDescription`,
    defaultMessage: 'Hàng ngàn nhà hàng và quán ăn đã tối ưu quy trình vận hành, tiết kiệm chi phí nhờ sản phẩm thương hiệu Kamereo. Để lại thông tin – Kamereo sẵn sàng đồng hành cùng bạn từ những bước đầu tiên.',
  }
});
